import { Form } from 'antd';
import UploadTypeSigin from '@/page/SignUp/uploadType';
import { useEffect } from 'react';
// import { getRules } from './util';
const AttachmentForm = (props) => {
    const onChangeDocList = (val,name)=>{
        props?.formRef?.current?.setFieldsValue({
            [name]:val
        });
        if(props.handleValuesChange){
            props.handleValuesChange({[name]:val});
        }
    };
    useEffect(()=>{
    },[]);
    return (
        <Form.Item key={props.field_id} name={props.en_name}>
            <UploadTypeSigin
                updatedInfo={props}
                onChangeDocList={onChangeDocList}
                auditState={1}
                dirname={props.dirname}
            />
        </Form.Item>
    );
};
export default AttachmentForm;